import React, { useEffect } from "react";
import { smlUrl } from "../../utils/config";

const DocusignReturn = () => {
  useEffect(() => {
    const parentUrl = smlUrl; // Replace with the actual parent URL
    const urlParams = new URLSearchParams(window.location.search);
    const event = urlParams.get("event");

    if (window.opener) {
      if (event === "sign-success") {
        window.opener.postMessage("sign-success", parentUrl); // Use the appropriate origin
      } else if (event === "signing_complete") {
        window.opener.postMessage("sign-success", parentUrl); // Use the appropriate origin
      } else if (event === "signing_cancelled") {
        window.opener.postMessage("signing_cancelled", parentUrl);
      } else if (event === "ttl_expired") {
        window.opener.postMessage("ttl_expired", parentUrl);
      } else if (event === "viewing_complete") {
        window.opener.postMessage("sign-success", parentUrl);
      } else if (event === "decline") {
        window.opener.postMessage("decline", parentUrl);
      }
      window.close();
    } else {
      console.log(
        "No opener window found. This page might not have been opened in a popup."
      );
    }
  }, []);

  return (
    <div>
      <h1>Processing...</h1>
      <p>
        Please wait while we process your signing event. This window will close
        automatically.
      </p>
    </div>
  );
};

export default DocusignReturn;
